import React, { Suspense, useEffect } from "react";
import { Routes, Route, Navigate, useNavigate } from "react-router-dom";
import { Loader } from "../Components/Loader";
import useUser from "../Core/hook/useUser";
import { Privileges } from "../Core/Enum/enum";
import AccessDenied from "../Components/AccessDenied/AccessDenied";
import NotFound from "../Components/NotFound/NotFound";

import Dashboard from "../Pages/Dashboard";

import Setting from "../Pages/Setting/index";

import CreateDepartment from "../Pages/Department/Create";
import ListDepartment from "../Pages/Department/List";

import CreateProduct from "../Pages/Product/Create/index";
import ListProduct from "../Pages/Product/List/index";
import ViewVarint from "../Pages/Product/View/index";

import CreateCategory from "../Pages/Category/Create";
import ListCategory from "../Pages/Category/List";

import CreateLooping from "../Pages/Looping/Create";
import ListLooping from "../Pages/Looping/List";

import CreateUser from "../Pages/User/create";
import ListUser from "../Pages/User/List";

import OrderListCreate from "../Pages/OrderList/Create/index";
import OrderList from "../Pages/OrderList/List";
import OrderListEdit from "../Pages/OrderList/Edit/index";
import OrderListView from "../Pages/OrderList/View";
import SentToManager from "../Pages/OrderList/Edit/sentToManager";
import AdminConformStorePrice from "../Pages/OrderList/PriceConfirmList";
import AdminEditedPrice from "../Pages/OrderList/PriceConfirmList/editPrice";
import PriceListView from "../Pages/OrderList/View/priceListView";
import UpdateConfirmPrice from "../Pages/OrderList/UpdateConfirmPrice/index";

import CreateUserRole from "../Pages/UserRole/Create";
import ListUserRole from "../Pages/UserRole/List";

import CreateUserPrivilege from "../Pages/Privilege/Create";
import ListUserPrivilege from "../Pages/Privilege/List";

import CreateRestaurant from "../Pages/Restaurant/Create";
import ListRestaurant from "../Pages/Restaurant/List";
import EditRestaurant from "../Pages/Restaurant/Edit";

import CreateMainItem from "../Pages/MainItem/Create";
import ListMainItem from "../Pages/MainItem/List";
import ViewMainItem from "../Pages/MainItem/View";

import ThemeColor from "../Pages/ThemeColor/Create";

import CreatePrinter from "../Pages/Printer/Create";
import ListPrinter from "../Pages/Printer/List";

import CreateTax from "../Pages/Tax/Create";
import ListTax from "../Pages/Tax/List";

import CreateTag from "../Pages/Tag/Create";
import ListTag from "../Pages/Tag/List";

import CreateBrand from "../Pages/Brand/Create";
import ListBrand from "../Pages/Brand/List";

import ListStore from "../Pages/Store/List";
import CreateStore from "../Pages/Store/Create";

import CreateDriver from "../Pages/Staff/Create";
import ListDriver from "../Pages/Staff/List";
import DriverHistory from "../Pages/Staff/View";
import EmployeePdf from "../Pages/Staff/Print/employeePdf";
import AllEmployeepdf from "../Pages/Staff/Print/allEmployeepdf";
import EmployeePayrollpdf from "../Pages/Staff/staffPdf/index";

import ListPuchDetails from "../Pages/Punch/List";

import ListSchedule from "../Pages/Attendance/List";
import AdminCreateSchedule from "../Pages/Attendance/AdminEdit/AdminCreate";

import CreatePosition from "../Pages/Position/Create";
import ListPosition from "../Pages/Position/List";

import ListPayroll from "../Pages/Payroll/List";
import ConfirmPayroll from "../Pages/Payroll/ConfirmPayroll/index";
import ViewPayroll from "../Pages/Payroll/View";
import EditPayroll from "../Pages/Payroll/Edit";
import EmpReportPayroll from "../Pages/Payroll/FullView";

import ReScheduleList from "../Pages/ScheduleList/List";
import CreateScheduleList from "../Pages/ScheduleList/Create";

import EmployeeTimeScheduleList from "../Pages/EmployeeTimeSchedule/List";
import EmployeeWeeklyReport from "../Pages/EmployeeTimeSchedule/WeeklyReport";
import EmployeeTimeCalenderScheduleList from "../Pages/EmployeeTimeSchedule/List/calender";
import RequestList from "../Pages/EmployeeTimeSchedule/Request/listEmailVeiw";
import RequestListViewList from "../Pages/EmployeeTimeSchedule/Request/viewlist";

import EmailSetting from "../Pages/EmailSetting/List";
import EmailSettingCreate from "../Pages/EmailSetting/Create";
import EmailTemplateCreate from "../Pages/EmailSetting/EmailTemplate/index";

import { Box, CircularProgress } from "@mui/material";

/**
 * AppRoutes will load the app routes.
 * @returns
 */
const AppRoutes = () => {
  const { userHasRight, isLoading } = useUser();
  const navigate = useNavigate();

  if (isLoading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="10vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Routes>
      <Route
        element={<Suspense fallback={<Loader />}></Suspense>}
        path="/fallback"
      />
      <Route
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.DashboardView) ? (
              <Dashboard />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
        path="/dashboard"
      />
      <Route
        path="/dashboard"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.DashboardView) ? (
              <Dashboard />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/setting"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.SettingView) ? <Setting /> : <Dashboard />}
          </Suspense>
        }
      />
      <Route
        path="/department/list"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.DepartmentView) ? (
              <ListDepartment />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/department/create"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.DepartmentView) ? (
              <CreateDepartment />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/product/create/:id"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.ItemsView) ? (
              <CreateProduct />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/category/list"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.CategoriesView) ? (
              <ListCategory />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/category/create"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.CategoriesView) ? (
              <CreateCategory />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/looping/list"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.LoopingView) ? (
              <ListLooping />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/looping/create"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.LoopingView) ? (
              <CreateLooping />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/product/list"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.ItemsView) ? (
              <ListProduct />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/user/create"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.UserView) ? <CreateUser /> : <Dashboard />}
          </Suspense>
        }
      />
      <Route
        path="/user/list"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.UserView) ? <ListUser /> : <Dashboard />}
          </Suspense>
        }
      />

      <Route
        path="/order/list/create"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.OrderList) ? (
              <OrderListCreate />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/order/list"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.OrderList) ? <OrderList /> : <Dashboard />}
          </Suspense>
        }
      />
      <Route
        path="/order/list/edit/:id"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.OrderList) ? (
              <OrderListEdit />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/order/list/view/:id"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.OrderList) ? (
              <OrderListView />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/user/role/create"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.UserView) ? (
              <CreateUserRole />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/user/role/list"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.UserView) ? (
              <ListUserRole />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/user/privilege/create"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.UserView) ? (
              <CreateUserPrivilege />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/user/privilege/list"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.UserView) ? (
              <ListUserPrivilege />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/order/list/sentToManager/edit/:id"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.OrderList) ? (
              <SentToManager />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/order/list/price/admin/edit/:id"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.OrderList) ? (
              <AdminConformStorePrice />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/branch/list"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.BranchView) ? (
              <ListRestaurant />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/branch/create"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.BranchView) ? (
              <CreateRestaurant />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/branch/edit/:id"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.BranchView) ? (
              <EditRestaurant />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/main/item/create"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.MainItemsView) ? (
              <CreateMainItem />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/main/item/list"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.MainItemsView) ? (
              <ListMainItem />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/main/item/view/:id"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.MainItemsView) ? (
              <ViewMainItem />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/theme-color"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.ThemeView) ? (
              <ThemeColor />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/printer/list"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.PrinterView) ? (
              <ListPrinter />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/printer/create"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.PrinterView) ? (
              <CreatePrinter />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/tax/list"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.TaxView) ? <ListTax /> : <Dashboard />}
          </Suspense>
        }
      />
      <Route
        path="/tax/create"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.ThemeView) ? <CreateTax /> : <Dashboard />}
          </Suspense>
        }
      />
      <Route
        path="/tag/list"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.TagView) ? <ListTag /> : <Dashboard />}
          </Suspense>
        }
      />
      <Route
        path="/tag/create"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.TagView) ? <CreateTag /> : <Dashboard />}
          </Suspense>
        }
      />
      <Route
        path="/brand/list"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.BrandView) ? <ListBrand /> : <Dashboard />}
          </Suspense>
        }
      />
      <Route
        path="/brand/create"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.BrandView) ? (
              <CreateBrand />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/store/list"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.StoreView) ? <ListStore /> : <Dashboard />}
          </Suspense>
        }
      />
      <Route
        path="/store/create"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.StoreView) ? (
              <CreateStore />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/team/create"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.StaffView) ? (
              <CreateDriver />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/team/list"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.StaffView) ? (
              <ListDriver />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/team-history/:id"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.StaffView) ? (
              <DriverHistory />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/punch/list"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.PunchDetailsView) ? (
              <ListPuchDetails />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/schedule/list"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.ScheduleView) ? (
              <ListSchedule />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/position/list"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.PositionView) ? (
              <ListPosition />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/position/create"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.PositionView) ? (
              <CreatePosition />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/payroll/list"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.PayrollView) ? (
              <ListPayroll />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/payroll/generate"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.GeneratePayroll) ? (
              <ConfirmPayroll />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/team/schedule/pdf/:id"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.StaffView) ? (
              <EmployeePdf />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/all/team/schedule/pdf/:id"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.StaffView) ? (
              <AllEmployeepdf />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />

      <Route
        path="/re-Schedule/list"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.ScheduleView) ? (
              <ReScheduleList />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/re-Schedule/create"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.ScheduleEdit) ? (
              <CreateScheduleList />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/schedule/list/one-day"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.ScheduleView) ? (
              <EmployeeTimeScheduleList />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/schedule/list/calender/one-day"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.ScheduleView) ? (
              <EmployeeTimeCalenderScheduleList />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/payroll/list/:id"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.PayrollView) ? (
              <ViewPayroll />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/attendance/create"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.ScheduleEdit) ? (
              <AdminCreateSchedule />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/payroll/list/edit/:id"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.PayrollView) ? (
              <EditPayroll />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/payroll/list/emp/report/:id"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.PayrollView) ? (
              <EmpReportPayroll />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/emp/report/:id"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.PayrollView) ? (
              <EmployeePayrollpdf />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/attendance/weekly/report"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.ScheduleView) ? (
              <EmployeeWeeklyReport />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/order/list/set/price/edit/:id"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.OrderList) ? (
              <AdminEditedPrice />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/order/list/set/price/list/:id"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.OrderList) ? (
              <PriceListView />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/variant/view/:id"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.MainItemsView) ? (
              <ViewVarint />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/order/list/update/price/orderlist/:id/store/:storeId"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.OrderList) ? (
              <UpdateConfirmPrice />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/email/setting/list"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.EmailView) ? (
              <EmailSetting />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/email/setting/create"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.EmailView) ? (
              <EmailSettingCreate />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/email/template/create"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.EmailView) ? (
              <EmailTemplateCreate />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/request/list"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.ScheduleView) ? (
              <RequestList />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/request/view/:id"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.ScheduleView) ? (
              <RequestListViewList />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route element={<NotFound />} path="*" />
      <Route element={<AccessDenied />} path="/access-denied" />
      <Route element={<Navigate replace to="/dashboard" />} path="" />
    </Routes>
  );
};

export default AppRoutes;
